import { ThermometerVerification } from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

import { withFoodControlPointInstance } from "./foodControlPointService";

export const addThermometerVerification =
  withFoodControlPointInstance<ThermometerVerification>();

export const updateThermometerVerification =
  withFoodControlPointInstance<ThermometerVerification>(true);

export async function getThermometerVerificationByInstanceId(id: string) {
  return axios
    .get<ThermometerVerification>(
      "/ThermometerVerifications/getthermometerverificationbyinstanceid",
      {
        params: { id },
      },
    )
    .then((res) => res.data);
}
